export default __webpack_public_path__ + "static/media/same-day.744360cd.png";